import { Alert } from '@platform/ui';
import { HeadContent } from '@tanstack/react-router';
import { type ReactNode, useEffect } from 'react';

/**
 * What renders outside the root match's boundaries, so the error, notFound and pending states keep it:
 * the app's single `<HeadContent />` and the toast host.
 *
 * Own module, and past the `@hub/router` barrel, so the spec can mount it without pulling in the route
 * tree that imports this file back.
 */
export function RootShell({ children }: { children: ReactNode }) {
  // HeadContent appends alongside index.html's fallback tags rather than replacing them, and the first tag
  // wins, so drop them once the route-driven ones are committed.
  useEffect(() => {
    for (const tag of document.head.querySelectorAll('[data-prehydration]')) {
      tag.remove();
    }
    document.getElementById('boot-skeleton')?.remove();
  }, []);

  return (
    <>
      <HeadContent />
      <Alert />
      {children}
    </>
  );
}
